import { render } from "./ReelsDetails.vue?vue&type=template&id=28479b70&scoped=true"
import script from "./ReelsDetails.vue?vue&type=script&lang=js"
export * from "./ReelsDetails.vue?vue&type=script&lang=js"

import "./ReelsDetails.vue?vue&type=style&index=0&id=28479b70&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28479b70"]])

export default __exports__